export default __webpack_public_path__ + "308104140a6e82a88389e40737ce6fe3.webp";